import axios from 'axios';

import { APPLICATION_HEADERS } from '../models/headers';
export const calcCapacity = (option) => {
  let sum = 0;

  if (option && option.availableSpaceList) {
    const avails = option.availableSpaceList;

    avails.map((avail) => {
      if (avail) {
        sum += avail.capacity;
      }
    });
  }

  return sum;
};

export const getUniqueListBy = (arr, key) => {
  if (arr) return [...new Map(arr.map((item) => [item[key], item])).values()];

  return [];
};

export const changeDateFormat = (date) => {
  const dateParts = date.split('-');
  const year = dateParts[0];
  const month = dateParts[1];
  const day = dateParts[2];
  let formattedMonth = new Date(Date.parse(date + 'T00:00:00')).toLocaleString('en-US', {
    month: 'short',
  });

  formattedMonth = formattedMonth.charAt(0).toUpperCase() + formattedMonth.slice(1);
  const formattedDate = `${day}-${formattedMonth}-${year}`;

  return formattedDate;
};

export const formatDate = (option) => {
  if (option && option.availableSpaceList && option.availableSpaceList.length > 0) {
    const availableSpaces = option.availableSpaceList;

    if (availableSpaces[0] && availableSpaces[0].dateAvailable) {
      const inputDate = availableSpaces[0].dateAvailable;

      if (new Date() >= new Date(inputDate)) {
        return 'Now';
      }

      return changeDateFormat(inputDate);
    }

    return '-';
  }

  return '-';
};

const formatNum = (num) => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

export const calcMonthTerms = (option) => {
  const monthTerms = {
    rateOneMonth: '',
    rateSixMonths: '',
    rateTwelveMonths: '',
    ratetwentyfourmonths: '',
    rateVariable: '',
  };
  let month = 0;
  let sixMonths = 0;
  let twelveMonths = 0;
  let twentyFourMonths = 0;
  let rateVariable = 0;

  const avails = option.availableSpaceList;
  const currency = avails[0] && avails[0].currency ? avails[0].currency : '';

  avails.map((avail) => {
    if (avail) {
      month += avail.rateOneMonth;
      sixMonths += avail.rateSixMonths;
      twelveMonths += avail.rateTwelveMonths;
      twentyFourMonths += avail.rateTwentyFourMonths;
      rateVariable += avail.rateVariable;
    }

    if (avail && avail.officeType === 'EXTERIOR') {
      avail.officeType = '(External)';
    }
    if (avail && avail.officeType === 'INTERIOR') {
      avail.officeType = '(Internal)';
    }
  });

  monthTerms.rateOneMonth = currency + ' ' + formatNum(month);
  monthTerms.rateSixMonths = currency + ' ' + formatNum(sixMonths);
  monthTerms.rateTwelveMonths = currency + ' ' + formatNum(twelveMonths);
  monthTerms.ratetwentyfourmonths = currency + ' ' + formatNum(twentyFourMonths);
  monthTerms.rateVariable = currency + ' ' + formatNum(rateVariable);

  if (formatNum(month) === '0') {
    monthTerms.rateOneMonth = 'Not Available';
  }
  if (formatNum(sixMonths) === '0') {
    monthTerms.rateSixMonths = 'Not Available';
  }
  if (formatNum(twelveMonths) === '0') {
    monthTerms.rateTwelveMonths = 'Not Available';
  }
  if (formatNum(twentyFourMonths) === '0') {
    monthTerms.ratetwentyfourmonths = 'Not Available';
  }

  return monthTerms;
};

export const reorderData = (ids, options) => {
  if (options) {
    const shortListed = [];
    const optionsCopy = options.slice();

    for (let i = ids.length - 1; i >= 0; i--) {
      const id = ids[i];
      const existingOptionIndex = optionsCopy.findIndex((val) => val.id === id);
      const existingOption = optionsCopy[existingOptionIndex];

      if (existingOption) {
        optionsCopy.splice(existingOptionIndex, 1);
        optionsCopy.unshift(existingOption);
        shortListed[existingOption.shortlistedOrder - 1] = existingOption;
      }
    }

    return [shortListed, optionsCopy];
  }
};

export const calcCostPerSeat = (option) => {
  let costPerSeat = 0;
  let totalCapacity = 0;
  let totalCost = 0;
  let ratesToInclude;

  if (typeof option?.ratesToInclude === 'string') {
    ratesToInclude = new Array();

    ratesToInclude = option?.ratesToInclude?.split(',');
  }

  if (Array.isArray(option?.ratesToInclude)) {
    ratesToInclude = option?.ratesToInclude;
  }
  // let ratesToInclude = new Array();

  // ratesToInclude = option?.ratesToInclude?.split(',');

  if (option) {
    if (ratesToInclude && option?.availableSpaceList?.length > 0) {
      const includedRates = [...ratesToInclude];
      const spaces = option.availableSpaceList;
      const currency = spaces[0] && spaces[0].currency;

      if (includedRates.includes('12')) {
        spaces.map((space) => {
          if (space && space.capacity) {
            if (space.rateTwelveMonths) {
              costPerSeat += space.rateTwelveMonths;
            }
            totalCapacity += space.capacity;
          }
        });
        totalCost = formatNum(costPerSeat);
        let totalCostPerSeat = costPerSeat && formatNum(Math.round(costPerSeat / totalCapacity));

        if (currency) {
          totalCostPerSeat = currency + ' ' + totalCostPerSeat;
          totalCost = currency + ' ' + totalCost;
        }

        return [totalCostPerSeat, totalCost];
      }

      if (includedRates.includes('6')) {
        spaces.map((space) => {
          if (space && space.capacity) {
            if (space.rateSixMonths) {
              costPerSeat += space.rateSixMonths;
            }
            totalCapacity += space.capacity;
          }
        });
        totalCost = formatNum(costPerSeat);
        let totalCostPerSeat = costPerSeat && formatNum(Math.round(costPerSeat / totalCapacity));

        if (currency) {
          totalCostPerSeat = currency + ' ' + totalCostPerSeat;
          totalCost = currency + ' ' + totalCost;
        }

        return [totalCostPerSeat, totalCost];
      }

      if (includedRates.includes('1')) {
        spaces.map((space) => {
          if (space && space.capacity) {
            if (space.rateOneMonth) {
              costPerSeat += space.rateOneMonth;
            }
            totalCapacity += space.capacity;
          }
        });
        totalCost = formatNum(costPerSeat);
        costPerSeat = costPerSeat && formatNum(Math.round(costPerSeat / totalCapacity));

        if (currency) {
          costPerSeat = currency + ' ' + costPerSeat;
          totalCost = currency + ' ' + formatNum(totalCost);
        }

        return [costPerSeat, totalCost];
      }

      if (includedRates.includes('24')) {
        spaces.map((space) => {
          if (space && space.capacity) {
            if (space.rateTwentyFourMonths) {
              costPerSeat += space.rateTwentyFourMonths;
            }
            totalCapacity += space.capacity;
          }
        });
        totalCost = formatNum(costPerSeat);
        let totalCostPerSeat = costPerSeat && formatNum(Math.round(costPerSeat / totalCapacity));

        if (currency) {
          totalCostPerSeat = currency + ' ' + totalCostPerSeat;
          totalCost = currency + ' ' + totalCost;
        }

        return [totalCostPerSeat, totalCost];
      }
    }

    if (
      option?.rateVariableTerm &&
      option.ratesToInclude &&
      option?.availableSpaceList?.length > 0
    ) {
      const customTerm = option?.rateVariableTerm?.split(' ')[0]?.trim();
      const spaces = option.availableSpaceList;
      const currency = spaces[0] && spaces[0].currency;

      if (option?.ratesToInclude?.includes(customTerm)) {
        spaces?.forEach((space) => {
          if (space) {
            if (space.rateVariable) {
              costPerSeat += space.rateVariable;
            }
            totalCapacity += space.capacity;
          }
        });
        totalCost = formatNum(costPerSeat);
        let totalCostPerSeat = formatNum(Math.round(costPerSeat / totalCapacity));

        if (currency) {
          totalCostPerSeat = currency + ' ' + totalCostPerSeat;
          totalCost = currency + ' ' + totalCost;
        }

        return [totalCostPerSeat, totalCost];
      }
    }
  }

  return [0, 0];
};

export const scrollClickHandler = (id) => {
  if (document.getElementById(id)) {
    window.scrollTo({
      top: document.getElementById(id).offsetTop - 25,
      behavior: 'smooth',
    });
  }
};

const deg2rad = (deg) => {
  return deg * (Math.PI / 180);
};

export const getDistanceFromLatLong = (lat1, lon1, lat2, lon2, unitVal) => {
  const R = unitVal && unitVal == 'miles' ? 3958.8 : 6371;
  // var R = 6371; // Radius of the earth in km
  // const R = 3958.8; //Radius in miles
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in

  return d;
};

export const getDistance = (coords, latLng, unitVal) => {
  if (coords) {
    if (latLng && latLng.length > 0) {
      const lat1 = latLng[1];
      const lat2 = coords[1];
      const lon1 = latLng[0];
      const lon2 = coords[0];

      const distance1 = parseFloat(getDistanceFromLatLong(lat1, lon1, lat2, lon2, unitVal)).toFixed(
        2,
      );

      const unit = unitVal == 'miles' ? 'Miles ' : 'KM ';

      return distance1 + ' ' + unit;
    }

    return '';
  }

  return '-';
};

const getDateFormatByLength = (length) => {
  switch (length) {
    case 2:
      return '2-digit';
    case 3:
      return 'short';
    case 4:
      return 'numeric';
  }
};

/**
 * Format date
 * @param {string} timeStamp  time in the seconds
 * @param {string} dateFormat template for formatting time,
 * Support MM/MMM, DD, YY/YYYY
 */
export const formatDatefromTimeStamp = (timeStamp, dateFormat) => {
  const en = 'en-US';
  const dateMarkers = {
    DAY: 'D',
    MONTH: 'M',
    YEAR: 'Y',
  };
  const updateTimeStamp = new Date(timeStamp).getTime();
  const dateFormats = Object.values(dateMarkers);
  const date = new Date(Number(updateTimeStamp));
  const formatedDate = dateFormat;

  dateFormats.forEach((format) => {
    const firstEntry = formatedDate.indexOf(format);

    if (firstEntry === -1) return;

    const lastEntry = formatedDate.lastIndexOf(format) + 1;
    const replaceArea = formatedDate.slice(firstEntry, lastEntry);

    const currentFormat = replaceArea[0].toUpperCase();

    switch (currentFormat) {
      case dateMarkers.MONTH: {
        const monthOption = { month: getDateFormatByLength(replaceArea.length) };
        const month = date.toLocaleDateString(en, monthOption);

        dateFormat = dateFormat.replace(replaceArea, month);
        break;
      }
      case dateMarkers.DAY: {
        const dayOption = { day: getDateFormatByLength(replaceArea.length) };
        const day = date.toLocaleDateString(en, dayOption);

        dateFormat = dateFormat.replace(replaceArea, day);
        break;
      }
      case dateMarkers.YEAR: {
        const yearOption = { year: getDateFormatByLength(replaceArea.length) };
        const year = date.toLocaleDateString(en, yearOption);

        dateFormat = dateFormat.replace(replaceArea, year);
        break;
      }
    }
  });

  return dateFormat;
};

export const formatDateTime = (dt) => {
  if (dt) {
    const m = new Date(dt);

    const dateString =
      m.getUTCFullYear() +
      '/' +
      (m.getUTCMonth() + 1) +
      '/' +
      m.getUTCDate() +
      ' ' +
      m.toLocaleDateString('en-US', { hour: 'numeric' });

    return dateString;
  }
};

export const splitMyString = (str, splitLength) => {
  const segments = str.split(/\s+/); // Split by one or more spaces

  const result = [];

  for (let i = 0; i < segments.length; i++) {
    // Check if the current and next segments together resemble a valid time format (e.g., '10:00 AM', '2:30 PM')

    if (
      i < segments.length - 1 &&
      /^(0?[1-9]|1[0-2]):[0-5][0-9](?:AM|PM)$/.test(segments[i] + ' ' + segments[i + 1])
    ) {
      result.push(segments[i] + ' ' + segments[i + 1]);

      i++; // Skip the next segment
    } else {
      result.push(segments[i]);
    }
  }

  return result;
};

export const sendHttpRequest = async (url, method, data) => {
  const headers = APPLICATION_HEADERS.dealHeaders;
  const res = await axios(url, { method, headers, data });

  return res;
};

export const getCurrentLocationCoordinates = async (placename) => {
  const url =
    process.env.REACT_APP_GOOGLE_MAPS_URL.trim() +
    '/api/geocode/json?address=' +
    encodeURIComponent(placename) +
    '&key=' +
    process.env.REACT_APP_GOOGLE_API_KEY.trim();

  const response = await axios.get(url);

  return response;
};

export const getAfterSevenDaysTimeStamp = (scheduledDate) => {
  const date = new Date(scheduledDate);

  date.setDate(date.getDate() + 7);

  return date.getTime();
};

// Checks if any non-whitespace text content exists
export const hasVisibleContent = (htmlString) => {
  const div = document.createElement('div');

  div.innerHTML = htmlString;

  return !!div.textContent.trim();
};

// Survey ID Validation
export const hasValidSurveyID = (sid) => {
  const patternToMatch = /^\d+x\d+$/;

  return patternToMatch.test(sid);
};
export const isRatesToInclude = (option, numStr) => {
  let ratesToInclude = new Array();

  ratesToInclude = option?.ratesToInclude.split(',');
  const isInclude = ratesToInclude.includes(numStr);

  return isInclude;
};

export const strToArray = (str) => {
  if (!str) {
    return str;
  }
  let newArray = new Array();

  newArray = str.split(',').map((item) => item?.trim());

  return newArray;
};

export const reorderShortListData = (options) => {
  if (options?.length > 0) {
    const optionsCopy = options.slice();
    // Filter and sort options by shortlistOrder if it's greater than zero.

    const sortedOptions = optionsCopy
      .filter((option) => option.shortlistedOrder > 0 && option.shortListed)
      .sort((a, b) => a.shortlistedOrder - b.shortlistedOrder);

    return sortedOptions;
  }
};

export const changeRequestedDate = (input) => {
  const [datePart, timePart] = input.includes(' - ') ? input.split(' - ') : [input, null];

  const date = new Date(datePart);

  const formattedDate = `${date.getDate()} ${date.toLocaleString('default', {
    month: 'short',
  })}, ${date.getFullYear()}`;

  return timePart ? `${formattedDate} - ${timePart}` : formattedDate;
};

export const swapShortListOrder = (shortListCopy, srcI, desI) => {
  return [
    {
      id: shortListCopy[srcI]?.optionId,
      shortListed: true,
      shortlistedOrder: desI + 1,
    },
    {
      id: shortListCopy[desI]?.optionId,
      shortListed: true,
      shortlistedOrder: srcI + 1,
    },
  ];
};

export const validateImageURLString = (url) => {
  const pattern = new RegExp('^(http://|https://)', 'i');

  if (typeof url === 'string' && pattern.test(url)) {
    return true;
  }

  return false;
};
